<template>
  <div>
    <div v-if="state.current == 'fillOut'">
      <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
        <b-form role="form" @submit.prevent="handleSubmit(onReview)">
          <b-row>
            <b-col>
              <b-form-checkbox v-model="form.notifyText" switch size="sm"
                >Text Message</b-form-checkbox
              >

              <div class="mt-2">
                <base-input-phone
                  class="mb-3"
                  :rules="form.notifyText ? 'required|phoneNumber' : ''"
                  mode="lazy"
                  name="cellPhoneNumber"
                  v-model="form.cell"
                  placeholder="Cell phone number"
                  :disabled="!form.notifyText"
                >
                </base-input-phone>

                <div class="text-muted small">
                  If you don't have an opt-in agreement, please verbalize the
                  <a href="#" @click.prevent="showOptIn = true"
                    >terms and service</a
                  >
                  to the patient before sending them a text.
                </div>
                <div class="text-muted small" v-if="showOptIn">
                  <br />
                  1. This application will send text messages to the paitient
                  when a user requests an amount due to be paid.<br />
                  <br />
                  2. You can cancel the SMS service at any time. Just text
                  "STOP" to the short code. After you send the SMS message
                  "STOP" to us, we will send you an SMS message to confirm that
                  you have been unsubscribed. After this, you will no longer
                  receive SMS messages from us. If you want to join again, just
                  sign up as you did the first time and we will start sending
                  SMS messages to you again.<br /><br />
                  3. If you are experiencing issues with the messaging program
                  you can reply with the keyword HELP for more assistance, or
                  you can get help directly at
                  {{ companyPhoneNumber }}.<br /><br />
                  4. Carriers are not liable for delayed or undelivered
                  messages<br /><br />
                  5. As always, message and data rates may apply for any
                  messages sent to you from us and to us from you. You will
                  receive a message when a user initiates a payment request. If
                  you have any questions about your text plan or data plan, it
                  is best to contact your wireless provider.<br /><br />
                  6. If you have any questions regarding privacy, please read
                  our
                  <a href="http://www.moolah.cc/privacy-policy/" target="_new"
                    >privacy policy.</a
                  >
                </div>
                <br />
              </div>
            </b-col>
            <b-col>
              <b-form-checkbox v-model="form.notifyEmail" switch size="sm">
                E-Mail</b-form-checkbox
              >

              <div class="mt-2">
                <base-input
                  class="mb-3"
                  :rules="form.notifyEmail ? 'required|email' : ''"
                  mode="lazy"
                  name="email"
                  :disabled="!form.notifyEmail"
                  v-model="form.email"
                  prependIcon="ni ni-email-83"
                  placeholder="E-mail address"
                >
                </base-input>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <base-textarea
                v-model="form.note"
                label="Note"
                rows="5"
                placeholder="Enter a note to the patient"
              />
            </b-col>
            <b-col>
              <base-input-currency
                class="mb-3"
                name="paymentAmount"
                ref="paymentAmount"
                rules="required|money"
                mode="lazy"
                label="Payment Amount"
                :disabled="!form.notifyText && !form.notifyEmail"
                v-model="form.paymentAmount"
                prependChar="$"
              >
              </base-input-currency>
            </b-col>
          </b-row>

          <b-button
            class="btn-block"
            variant="primary"
            type="submit"
            :disabled="!form.notifyText && !form.notifyEmail"
            >Send Notification(s)</b-button
          >
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>

<script>
export default {
  name: "text-to-pay",
  props: { customer: null },
  data: function() {
    return {
      showOptIn: false,
      form: {
        notifyEmail: true,
        notifyText: true,
        email: null,
        cell: null,
        note: null,
        paymentAmount: "",
      },
      state: {
        current: "fillOut",
      },
      companyPhoneNumber: null,
      notificationOptions: [
        { value: "EMAIL", text: "E-Mail" },
        { value: "TEXT", text: "Text Message" },
      ],
    };
  },

  methods: {
    async onReview() {
      var self = this;

      self.form.customerId = self.customer.id;

      var r = await self.$client.post(
        "/api/notification/sendNotification",
        self.form
      );

      let message =
        "A payment request for " +
        self.$options.filters.currency(self.form.paymentAmount) +
        " has been sent to " +
        self.customer.firstName +
        "’s ";
      if (r.data.isSuccess) {
        if (self.form.notifyEmail & !self.form.notifyText) {
          message += "email.";
        }
        if (!self.form.notifyEmail & self.form.notifyText) {
          message += "mobile.";
        }

        if (self.form.notifyEmail & self.form.notifyText) {
          message += "mobile and email.";
        }

        self.$emitter.emit("success-confirm", {
          title: "Payment Request Sent",
          message: message,
          navigate: "/#/dashboard",
        });
      }
    },
  },
  created() {
    var self = this;

    if (self.customer && self.customer.balance) {
      if (self.customer.balance > 0)
        this.form.paymentAmount = self.customer.balance;
    }

    this.form.email = this.customer.email;
    this.form.cell = this.customer.cell;

    self.companyPhoneNumber = self.$localStorageService.getItem("companyPhone");
    this.$refs.paymentAmount.$el.querySelector("input").focus();
  },
};
</script>
<style>
.scale {
  transform: scale(2);
}
</style>
